import { API_URLS } from '../config/api';
import { apiPut } from '../utils/apiUtils';

export const useNovelUpdate = (novelId, isProduction, refreshNovel) => {
  const updateNovel = async (updatedNovel, successMessage = '') => {
    const apiEndpoint = isProduction
      ? `${API_URLS.PRODUCTION_NOVELS}/${novelId}`
      : `${API_URLS.BUILDING_NOVELS}/${novelId}`;
    await apiPut(apiEndpoint, updatedNovel, {}, !!successMessage, successMessage);
    await refreshNovel();
  };

  return { updateNovel };
};
